import template from 'lodash/template';
import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import capitalize from 'lodash/capitalize';
import {Helmet} from 'react-helmet-async';
import withConfig from 'config/withConfig';

function Category({siteUrl}) {
    const {
        category: {slug, results},
        city: {
            display_name: cityName,
            slug: citySlug,
            default_image: {url_template: cityImageTemplate},
        },
    } = useSelector(({category: {data: category}, city: {data: city}}) => ({
        category,
        city,
    }));

    const categoryName = capitalize(slug);
    const title = `${cityName} ${categoryName} Parking`;
    const bgImage = template(cityImageTemplate, {
        interpolate: /{{([\s\S]+?)}}/g, // matches template vars in the format '{{ var }}' or '{{var}}'
    })({
        WIDTH: 1200,
        HEIGHT: 347,
        QUALITY: 50,
    });

    const canonical = `${siteUrl}/category/${citySlug}/${slug}-parking`;

    const hero = () => (
        <div className="Category-hero">
            <div
                className="Category-hero-image"
                style={{backgroundImage: `url("${bgImage}")`}}
            />
            <div className="Category-hero-shim" />
            <h1 className="Category-hero-title">{title}</h1>
        </div>
    );

    const breadcrumbs = () => (
        <div className="Category-breadcrumbs">
            <ul itemScope itemType="http://schema.org/BreadcrumbList">
                <li
                    itemScope
                    itemProp="itemListElement"
                    itemType="http://schema.org/ListItem"
                >
                    <a href="/" itemProp="url">
                        <span itemProp="name">Home</span>
                    </a>
                    <meta itemProp="position" content="1" />
                </li>
                <li
                    itemScope
                    itemProp="itemListElement"
                    itemType="http://schema.org/ListItem"
                >
                    <a href={`/${citySlug}-parking`} itemProp="url">
                        <span itemProp="name">{cityName} Parking</span>
                    </a>
                    <meta itemProp="position" content="2" />
                </li>
                <li itemScope itemProp="false" itemType="false">
                    <span>{categoryName}</span>
                </li>
            </ul>
        </div>
    );

    const destinations = () => (
        <div className="Category-list">
            <ul>
                {results.map(({title: name, relative_url: url}, idx) => (
                    <li key={idx} itemScope itemType="http://schema.org/Place">
                        <a
                            itemProp="url"
                            href={`/destination/${citySlug}/${url}`}
                        >
                            <span itemProp="name">{name}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className="Category">
            <Helmet>
                <title>{title}</title>
                <link rel="canonical" href={canonical} />
                <body className="standalone-page" />
            </Helmet>
            {hero()}
            {breadcrumbs()}
            {destinations()}
        </div>
    );
}

Category.propTypes = {
    siteUrl: PropTypes.string.isRequired,
};

export default withConfig(['siteUrl'])(Category);
